const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

export const resolveAssetUrl = (pathOrUrl) => {
  if (!pathOrUrl) return "";
  if (pathOrUrl.startsWith("http://") || pathOrUrl.startsWith("https://")) {
    return pathOrUrl;
  }
  if (pathOrUrl.startsWith("/assets/")) {
    return `${BASE_URL}${pathOrUrl}`;
  }
  return `${BASE_URL}/assets/${pathOrUrl}`;
};

